import { useEffect } from 'react';
import { LoggerTags } from 'utils/log/constants/loggerTags';
import logToBackend from 'utils/log/logToBackend';

const useClientSideErrorReporting = () => {
  useEffect(() => {
    const handleErrors = ({ error }: ErrorEvent) => {
      const err = error as Error;

      logToBackend(LoggerTags.CLIENT_ERROR, err.name, {
        message: err.message,
        traceback: err.stack,
        url: window.location.href,
      });
    };

    const handlePromiseRejections = ({ reason }: PromiseRejectionEvent) => {
      const { message } = reason as Error;
      const traceback = (reason as Error).stack;

      const reasonIsError = typeof message === 'string' && typeof traceback === 'string';

      logToBackend(LoggerTags.CLIENT_ERROR, 'UnhandledRejection', {
        ...(reasonIsError
          ? {
              message,
              traceback,
            }
          : {}),
        url: window.location.href,
      });
    };

    window.addEventListener('error', handleErrors);
    window.addEventListener('unhandledrejection', handlePromiseRejections);

    return () => {
      window.removeEventListener('error', handleErrors);
      window.removeEventListener('unhandledrejection', handlePromiseRejections);
    };
  }, []);
};

export default useClientSideErrorReporting;
